import React from 'react'
import Header from '../common/header'
import JumpOnYourDay from './jump_on_your_day'
import WorkSmarter from './work_smarter'
import Product from './product'
import Stretches from './stretches'
import AchesPains from './aches_pains'
import Footer from '../common/footer'
import GetKeybreakToday from './get_keybreak_today'
import FineTuning from './fine_tuning'
import Testimonials from './testimonials'

export default () => (
    <>
        <Header />
        <JumpOnYourDay />
        <Stretches />
        <WorkSmarter />
        <Product />
        <AchesPains />
        <FineTuning />
        <Testimonials />
        <GetKeybreakToday />
        <Footer />
    </>
)
